import { Directive, HostListener   } from '@angular/core';

@Directive({
  selector: '[digitalOnly]'
})

export class DigitalOnlyDirective {

  @HostListener('keydown', ['$event'])
    onKeyDown(e: KeyboardEvent) {
        let code = e.code;
        if (
            // Allow: Delete, Backspace, Tab, Escape, Enter
            (['Delete', 'Backspace', 'Tab', 'Escape', 'Enter'].indexOf(code) !== -1) || 
            ((e.ctrlKey === true) && (['KeyA','KeyC','KeyV','KeyX'].indexOf(code) !== -1)) || // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X            
            (['Home', 'End', 'ArrowLeft', 'ArrowRight'].indexOf(code) !== -1) // Home, End, Left, Right
        ) {
            return;  // let it happen, don't do anything
        }
        // Ensure that it is a number and stop the keypress
        if (
            (e.shiftKey || code.indexOf('Digit') == -1 && code.indexOf('Numpad') == -1)
        ) {
            e.preventDefault();
        }
    }
}